import router from '@router'
import store from '@state/store'
import popup from '@utils/popup.js'
import $ from '@utils/axios.js'
import App from './app.vue'
import Vue from 'vue'
import axios from 'axios'

// Globally register all `_base`-prefixed components
import '@components/_globals'

Vue.prototype.$popup = popup
Vue.prototype.$ = $
if (process.env.VUE_APP_API_HOST) {
  Vue.prototype.$.defaults.baseURL = process.env.VUE_APP_API_HOST
}

Vue.prototype.$http = axios
if (process.env.VUE_APP_API_HOST) {
  Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_API_HOST
}

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}

store.dispatch('env/fetchMapboxToken')
